import { Button, Container, Group, Title } from '@mantine/core';
import { IconExclamationCircleFilled } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import classes from './PageError.module.css';

export function PageError() {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.label}>
          <IconExclamationCircleFilled size={60} />
        </div>
        <Title className={classes.title}>{t('pageError.title')}</Title>
        <Group justify="center">
          <Button
            variant="outline"
            size="md"
            onClick={() => {
              location.href = '.';
            }}
          >
            {t('pageError.retry')}
          </Button>
        </Group>
      </Container>
    </div>
  );
}
